export default __webpack_public_path__ + "static/media/icons.a3f0891a.ttf";